<template>
    <PortfolioMyInvestments
        :orders-per-issuer-active="portfolioState.ordersPerIssuerActiveItems"
        :orders-per-issuer-completed="portfolioState.ordersPerIssuerCompletedItems"
        :loading="
            portfolioState.ordersPerIssuerActiveItemsLoading || portfolioState.ordersPerIssuerCompletedItemsLoading
        "
        :icon-bold="true" />
</template>

<script setup lang="ts">
import PortfolioMyInvestments from '../account/portfolio/PortfolioMyInvestments.vue'
import { usePortfolio } from '../../utilities/portfolio/usePortfolio'

const { state: portfolioState } = usePortfolio()
</script>

<style scoped></style>
